import { gql } from "@apollo/client";

export const QUERY_DECISIONS = gql`
  query decisions(
    $name: String!
    $postcode: String!
    $offset: Int
    $limit: Int
  ) {
    decisions {
      data: decisions(
        name: $name
        postcode: $postcode
        pagination: { offset: $offset, limit: $limit }
      ) {
        totalCount
        pageInfo {
          limit
          offset
        }
        results {
          uuid
          applicantNames
          createdOn
          address
          amount
          termMonths
        }
      }
    }
  }
`;
